import { useBoundStore } from "useStore";
import { useMemo } from "react";
import FilterChip from "./FilterChip";
import { timeRangeOptions } from "../Table/utils";

export default function TimeRangeFilterChip() {
  const selectedTimeRange = useBoundStore(
    (state) => state.campaignManagerSelectedTimeRange,
  );
  const dateRange = useBoundStore((state) => state.campaignManagerRangeDate);
  const clearDateRange = useBoundStore(
    (state) => state.clearCampaignManagerRangeDate,
  );
  const clearSelectedTimeRange = useBoundStore(
    (state) => state.clearCampaignManagerSelectedTimeRange,
  );

  const formattedTimeRange = useMemo(() => {
    const label = timeRangeOptions.find(
      (option) => option.value === selectedTimeRange,
    )?.label;

    const formatDate = (date) => {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    };

    if (Array.isArray(dateRange) && dateRange.length === 2) {
      return `${label}: ${formatDate(dateRange[0])}${
        dateRange[1] ? ` - ${formatDate(dateRange[1])}` : ""
      }`;
    }

    return `${label}: ${formatDate(dateRange)}`;
  }, [selectedTimeRange, dateRange]);

  if (!dateRange) return null;

  return (
    <FilterChip
      filterName="Rango de fechas"
      title={formattedTimeRange}
      onDelete={() => {
        clearSelectedTimeRange();
        clearDateRange();
      }}
    />
  );
}
